export const DATE_FORMAT_BASIC = "yyyy-MM-dd";
export const DATE_FORMAT_BASIC_TIME = "yyyy-MM-dd, h:mm a";
export const DATE_FORMAT_VERBOSE = "MMM d, yyyy";
export const DATE_FORMAT_MONTH_DAY = "MMM d";
export const DATE_FORMAT_DAY_MONTH_YEAR_HOURS = "d MMM yyy, h:mm a";
